import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import BreadcrumbPath from '../Common/BreadcrumbPath';

interface ConfirmMoveFileModalProps {
  fileName: string;
  currentPath: string;
  targetPath: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

/**
 * Enterprise-grade move file confirmation modal
 * Compact, standardized design with path visualization
 */
const ConfirmMoveFileModal: React.FC<ConfirmMoveFileModalProps> = ({
  fileName,
  currentPath,
  targetPath,
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  return (
    <Modal 
      show={true} 
      onHide={onCancel} 
      centered 
      size="sm"
      backdrop="static"
      keyboard={!isLoading}
    >
      <Modal.Header closeButton={!isLoading} className="border-bottom-0 pb-2">
        <Modal.Title className="h6 mb-0">
          <i className="fas fa-file text-info mr-2"></i>
          Move File
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-2 pb-3">
        <div className="bg-light border rounded p-2" style={{ fontSize: '0.85rem' }}>
          <div className="mb-2">
            <small className="text-muted d-block mb-1" style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase' }}>
              File
            </small>
            <div className="bg-white border rounded px-2 py-1" style={{ fontFamily: 'monospace', fontSize: '0.8rem', wordBreak: 'break-all' }}>
              <i className="fas fa-file text-info mr-1"></i>
              {fileName}
            </div>
          </div>
          <div className="mb-2">
            <small className="text-muted d-block mb-1" style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase' }}>
              Current Location
            </small>
            <div className="bg-white border rounded px-2 py-1">
              <BreadcrumbPath path={currentPath} showIcon={true} />
            </div>
          </div>
          <div>
            <small className="text-muted d-block mb-1" style={{ fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase' }}>
              New Location
            </small>
            <div className="bg-white border rounded px-2 py-1">
              <BreadcrumbPath path={targetPath} showIcon={true} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <Button 
          variant="light" 
          size="sm"
          onClick={onCancel}
          disabled={isLoading}
          className="px-3"
        >
          Cancel
        </Button>
        <Button 
          variant="primary" 
          size="sm"
          onClick={onConfirm}
          disabled={isLoading}
          className="px-3"
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              Moving...
            </>
          ) : (
            'Move File'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmMoveFileModal;
